module.exports = __webpack_public_path__ + "img/new.585e3cfc.webp";